<template>
</template>

<script>
</script>

<style>
</style>
<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">
      <img src="~@/common/imgs/talent.jpg" alt="">
    </div>

    <!-- content -->
    <div class="talent-infor">
      <div class="talent-title">
        <h2>招聘岗位</h2>/<i>人尽其才，人尽其用</i>
      </div>
      <el-card class="box-card" v-for="item in dataList" :key="item.id">
        <div slot="header" class="clearfix">
          <h2><i class="el-icon-s-cooperation"></i> {{item.positionName}}</h2>
          <span>工作地点：{{item.workAddr}} 工作年限：{{item.workYear}} 学历：{{item.profession}}</span>
        </div>
        <div class="text item">
          <h3>任职资格：</h3>
          <p v-html="turn(item.importantDesc)"></p>
          <h3>岗位职责：</h3>
          <p v-html="turn(item.generalDesc)"></p>
        </div>
      </el-card>

      <div class="contact-infor">
        <h2><i class="el-icon-s-promotion"></i>联系方式</h2>
        <p><i class="el-icon-message"></i>简历投递邮箱：hj_hr@szhuajian.cn</p>
        <p><i class="el-icon-user"></i>联系人：温小姐、王小姐</p>
        <p><i class="el-icon-phone-outline"></i>电话：83211333—8921、83211333-8867</p>
      </div>

    </div>
     <!-- 回到顶部 -->
    <el-backtop></el-backtop>
    <!-- footer -->
    <foot-link></foot-link>

    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import axios from 'axios'
  import global_msg from '@/common/js/global.js'

  export default {
    name: 'Talent',
    data() {
      return {
        dataList: []
      }
    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    },
    mounted() {
      // 请求招聘列表
      // axios.get(global_msg.baseUrl + 'ntWebsitejob/findByAll?rows=1000&page=1&jobIsshow=1').then((response) => {
      //   this.dataList = response.data.rows;
      // });
      axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findByAll?sendType=人才招聘').then((response) => {
        this.dataList = response.data.subject.result;
      });
    },
    methods: {
      turn(data){
        return data.replace(/(\r\n|\n|\r)/gm, "<br />")
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Talent.vue